import type { NewsFeedItem } from '../../types';

/** Stable list key: an article and a document can share an id. */
export function feedKey(item: NewsFeedItem): string {
    return `${item.kind}-${item.id}`;
}
